"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.auth = (0, basic_1.applyBase)({
    b2bLoginLayout: {
        backgroundColor: 'bgLightBlue',
        pt: [0, '45px'],
        pb: [0, '75px'],
        '.error': {
            mt: -3,
            mb: 3,
        },
    },
    loginSocialButton: {
        p: 0,
        display: 'flex',
        alignItems: 'center',
        height: ['52px', '55px'],
        overflow: 'hidden',
        width: ['100%', '310px'],
        '.login-social-text': Object.assign({ pl: [5, '18px'] }, font_faces_1.FONT_SIZE.LARGE),
        '.login-social-icon': {
            width: ['52px', '55px'],
            height: ['52px', '55px'],
            padding: '16px',
        },
    },
    loginSocialWrapper: {
        display: 'flex',
        gap: [3, '35px'],
        justifyContent: 'center',
        width: '100%',
        py: [4, '40px'],
        flexDirection: ['column', 'row'],
        alignItems: 'center',
        px: [4, 0],
    },
    loginSocialTop: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        px: [4, 0],
        '.decoration-line-span': {
            height: '1px',
            width: '100%',
            display: 'block',
            borderTop: '1px solid',
            borderColor: 'borderColor',
            flexGrow: 1,
        },
        '.or-span': {
            pt: [null, 2],
            px: [2, 3],
            color: 'secondary',
            flexShrink: '0',
            lineHeight: ['1.3', '1'],
            fontSize: [1, 2],
        },
    },
    panelContent: {
        position: 'relative',
        px: [null, 1],
    },
    b2cLoginLinkWrapper: {
        'button, a': font_faces_1.FONT_SIZE.MEDIUM,
    },
    errorMessage: {
        mb: 3,
        color: basic_1.basic.colors.error,
    },
    formTitleStyles: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.S), { mb: [4, '25px'] }),
    formTextStyles: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { mb: [4, '25px'] }),
    loginLayoutBlockStyles: {
        maxWidth: [null, '970px'],
        backgroundColor: 'white',
        boxShadow: [null, 'blockShadow'],
        mx: [null, 'auto'],
        flexWrap: 'wrap',
        '.layout-text': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { mb: [4, '50px'] }),
    },
    formModalWrapperStyles: {
        width: '100%',
        maxWidth: '450px',
        position: 'relative',
        height: [null, 'auto'],
        borderRadius: ['roundedTop', '0px'],
        '.modal-body, .modal-header': {
            backgroundColor: 'white',
        },
    },
    loginForm: {
        '.text-input': {
            mb: [3, 4],
            '&:last-of-type': {
                mb: 4,
            },
        },
        '.login-form-submit': {
            width: '100%',
            marginBottom: [3, '20px'],
        },
        '.login-form-forgot-button': {
            py: 2,
        },
    },
});
//# sourceMappingURL=auth.js.map